import { useState, useEffect } from 'react';
import './BookingModal.css';

interface BookingModalProps { isOpen: boolean; onClose: () => void; }

const services = ['Corte Clásico – $65.000', 'Corte + Barba – $95.000', 'Arreglo de Barba – $55.000', 'Afeitado Clásico – $70.000', 'Tratamiento Capilar – $85.000', 'Corte Infantil – $45.000'];
const timeSlots = ['8:30', '9:15', '10:00', '10:45', '11:30', '13:30', '14:15', '15:00', '15:45', '16:30', '17:15'];

export default function BookingModal({ isOpen, onClose }: BookingModalProps) {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [charCount, setCharCount] = useState(0);

  useEffect(() => {
    if (isOpen) { document.body.style.overflow = 'hidden'; setSubmitted(false); }
    else { document.body.style.overflow = ''; }
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    const form = e.currentTarget;
    const data = new URLSearchParams();
    const elements = form.elements as HTMLFormControlsCollection;
    for (let i = 0; i < elements.length; i++) {
      const el = elements[i] as HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement;
      if (el.name && el.value && el.tagName !== 'BUTTON') data.append(el.name, el.value);
    }
    try {
      await fetch('https://readdy.ai/api/form/d72vpkgvgh40rhf9r8f0', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: data.toString() });
      setSubmitted(true);
    } catch { setSubmitted(true); } finally { setLoading(false); }
  };

  if (!isOpen) return null;

  return (
    <div className="booking-modal-overlay fixed inset-0 z-[100] flex items-center justify-center p-4">
      <div className="booking-modal-backdrop absolute inset-0" onClick={onClose} />
      <div className="booking-modal relative">
        <div className="booking-modal-top-line" />
        <div className="booking-modal-header">
          <div>
            <p className="booking-modal-label">◆ Reserva ◆</p>
            <h2 className="booking-modal-title">Reservar Cita</h2>
          </div>
          <button onClick={onClose} className="booking-modal-close cursor-pointer">
            <i className="ri-close-line text-lg" />
          </button>
        </div>
        <div className="booking-modal-body">
          {submitted ? (
            <div className="booking-success">
              <div className="booking-success-icon">
                <i className="ri-checkbox-circle-fill" />
              </div>
              <h3 className="booking-success-title">¡Cita Reservada!</h3>
              <p className="booking-success-message">Hemos recibido tu solicitud. Te confirmaremos tu cita por teléfono o email en breve.</p>
              <button onClick={onClose} className="booking-success-close cursor-pointer">Cerrar</button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} data-readdy-form id="reservar-cita-form" className="space-y-5">
              <div className="booking-form-group">
                <label className="booking-form-label">Nombre completo *</label>
                <input type="text" name="nombre" required placeholder="Tu nombre" className="booking-form-input" />
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="booking-form-group">
                  <label className="booking-form-label">Teléfono *</label>
                  <input type="tel" name="telefono" required placeholder="+57 300 000 0000" className="booking-form-input" />
                </div>
                <div className="booking-form-group">
                  <label className="booking-form-label">Email *</label>
                  <input type="email" name="email" required placeholder="tu@email.com" className="booking-form-input" />
                </div>
              </div>
              <div className="booking-form-group">
                <label className="booking-form-label">Servicio *</label>
                <select name="servicio" required className="booking-form-input booking-form-select">
                  <option value="">Selecciona un servicio</option>
                  {services.map((s) => <option key={s} value={s}>{s}</option>)}
                </select>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="booking-form-group">
                  <label className="booking-form-label">Fecha *</label>
                  <input type="date" name="fecha" required className="booking-form-input cursor-pointer" />
                </div>
                <div className="booking-form-group">
                  <label className="booking-form-label">Hora *</label>
                  <select name="hora" required className="booking-form-input booking-form-select">
                    <option value="">Selecciona hora</option>
                    {timeSlots.map((t) => <option key={t} value={t}>{t}</option>)}
                  </select>
                </div>
              </div>
              <div className="booking-form-group">
                <label className="booking-form-label">Notas adicionales</label>
                <textarea name="notas" rows={3} maxLength={500} placeholder="Cuéntanos algo sobre el estilo que deseas..." onChange={(e) => setCharCount(e.target.value.length)} className="booking-form-input booking-form-textarea" />
                <p className="booking-form-char-count">{charCount}/500</p>
              </div>
              <button type="submit" disabled={loading} className="booking-form-submit cursor-pointer">
                {loading ? (<><i className="ri-loader-4-line animate-spin" />Enviando...</>) : 'Confirmar Reserva'}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}